import Vue from 'vue';
import moment from "moment";


export default {

  SET_VERSION_ID(state, data) {
    state.kind[data.kind].versionId = data.version_id
    state.kind[data.kind].versionName = data.version_name
  },
  SET_LEVEL_GAUGE_DASHBOARD(state, data) {
    state.levelGaugeDashboard = data;
  },
  SET_LOST_DATA(state, data) {
    Vue.set(state.lostData, data.vesselId, data.data)
    state.levelGaugeLastUpdatedAt = moment().valueOf();
  },
  SET_LEVEL_GAUGE(state, data) {
    Vue.set(state.levelGauge, data.vesselId, data.data)
    state.levelGaugeLastUpdatedAt = moment().valueOf();
  },
  SET_CHANNEL_MASTER(state, data) {
    state.channelMaster[data.kind] = data.channelMaster
  },
  SET_HANASYS_EXPERT(state, data) {
    // state.hanasysExpert[data.id] = data.data;
    Vue.set(state.hanasysExpert, data.id, data.data);

    state.hanasysExpertLastUpdatedAt = moment().unix();
  },
  SET_ENTERPRISE_VESSELS_WITH_CONTAINERS(state, data) {
    state.enterpriseVesselsWithContainers[data.enterprise_vessel_id] = data
  },
  SET_VOYAGE_HISTORY_DETAIL(state, data) {
    state.voyageHistoryDetail = data
  },
  SET_REPORTS(state, data) {
    state.reports = data;
  },

  ADD_FIRESTORE_SUBSCRIBE_LIST(state, data) {
    state.firestoreSubscribeList.push(data);
  },
  UNSUBSCRIBE_FIRESTORE(state) {
    if (state.firestoreSubscribeList.length > 0) {
      state.firestoreSubscribeList.forEach(unsubscribe => {
        unsubscribe();
      });
    }
  },
}